import { render, staticRenderFns } from "./ReleaseNotesPage.vue?vue&type=template&id=3d7c49b2&scoped=true&"
import script from "./ReleaseNotesPage.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c49b2",
  null
  
)

export default component.exports